import React, { useState } from "react";
import { Paper, Theme, Typography } from "@mui/material";
import { FormProvider } from "../../../provider/Form/FormProvider";
import ExternalLawyerApplicationForm from "./ExternalLawyerApplicationForm";
import * as messagesActions from "../../../store/messages/actions";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import ApiClient from "../../../services/apiClient";
import { postMediaObject } from "../../../services/mediaObjects";
import Container from "@/src/components/Container/Container";

export default function ExternalLawyerApplicationSection() {
  const [isLoading, setIsLoading] = useState(false);
  const [refreshForm, setRefreshForm] = useState(0);
  const [lawyerCertificate, setLawyerCertificate] = useState<File[]>([]);
  const [specialistLawyerCertificate, setSpecialistLawyerCertificate] = useState<File[]>([]);

  const handleSubmit = async ({ values }: any) => {
    setIsLoading(true);
    let data = _cloneDeep(values);
    const lawyerCertificateResponse = await postMediaObject(lawyerCertificate[0], "lawyerCertificate");
    data.lawyerCertificate = "/media_objects/" + lawyerCertificateResponse.id;
    if (!_isEmpty(specialistLawyerCertificate)) {
      const specialistLawyerCertificateResponse = await postMediaObject(specialistLawyerCertificate[0], "lawyerCertificate");
      data.specialistLawyerCertificate = "/media_objects/" + specialistLawyerCertificateResponse.id;
    }
    data.weeklyHours = parseInt(data.weeklyHours, 10);
    data.hasSpecialistTitles = data.hasSpecialistTitles === "true";
    await ApiClient.post("/external_lawyer_applications", { body: JSON.stringify(data) });
    messagesActions.addMessage({
      type: "success",
      text: "Vielen Dank für Ihr Interesse an einer Zusammenarbeit mit uns! Wir prüfen nun Ihre Bewerbung.",
    });
    setLawyerCertificate([]);
    setSpecialistLawyerCertificate([]);
    setIsLoading(false);
    setRefreshForm(refreshForm + 1);
  };

  const initialValues = {
    gender: "",
    givenName: "",
    familyName: "",
    streetAddress: "",
    postalCode: "",
    addressLocality: "",
    email: "",
    telephone: "",
    yearsOfExperience: "",
    hasSpecialistTitles: "",
    specialistTitles: [],
    legalFieldExperience: [],
    weeklyHours: "",
    taskType: [],
    referenceSites: "",
  };

  return (
    <Container variant={"sm"} id={"bewerben"}>
      <Typography component={"h2"} variant={"h3"} sx={{ textAlign: "center", marginBottom: "1rem" }}>
        Uns ist die hohe Qualifikation unserer Partneranwälte wichtig.
      </Typography>
      <Typography sx={{ textAlign: "center", marginBottom: "2rem" }} variant={"body1"}>
        Deshalb prüfen wir Ihre Angaben kurz, bevor Ihr Legalbird-Konto freigeschaltet wird. Danach vergeben Sie Ihr Passwort und können sofort starten.
      </Typography>
      <Paper
        sx={(theme: Theme) => ({
          padding: "3rem 1rem",
          [theme.breakpoints.up("md")]: {
            padding: "4rem 8rem",
          },
        })}
      >
        <FormProvider initialValues={initialValues} submitAction={handleSubmit} key={refreshForm}>
          <ExternalLawyerApplicationForm
            isLoading={isLoading}
            setLawyerCertificate={setLawyerCertificate}
            lawyerCertificate={lawyerCertificate}
            setSpecialistLawyerCertificate={setSpecialistLawyerCertificate}
            specialistLawyerCertificate={specialistLawyerCertificate}
          />
        </FormProvider>
      </Paper>
    </Container>
  );
}
